import { Capacitor } from '@capacitor/core';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { Button } from '@travelwin/core';
import { Trans } from 'react-i18next';

import GlobalErrorScreen from './components/GlobalErrorScreen/GlobalErrorScreen';

export const ApiCompatibilityErrorScreen = () => {
  return (
    <GlobalErrorScreen
      header={
        <Trans
          i18nKey="global_error_page.version_invalid_header"
          defaults={'Please update the app'}
        />
      }
      message={
        <Trans
          i18nKey="global_error_page.version_invalid_message"
          defaults={'An important update is available and required to continue'}
        />
      }
      button={
        Capacitor.isNativePlatform() ? (
          <Button
            data-testid="button-update-app"
            fluid
            onClick={() => AppUpdate.openAppStore()}
          >
            {
              <Trans
                i18nKey="global_error_page.update_button_label"
                defaults={'Check for updates'}
              />
            }
          </Button>
        ) : (
          <Button
            data-testid="button-update-app"
            fluid
            onClick={() => {
              location.href = '/';
            }}
          >
            {<Trans i18nKey="label.refresh_page" defaults={'Refresh Page'} />}
          </Button>
        )
      }
    />
  );
};
